// Module
var code = `<section class="ai-responses-surface">

  <header class="ai-responses-header">
    <h2 class="ai-responses-headline">{{headline}}</h2>
    <p class="ai-responses-subheadline">{{subheadline}}</p>
    <p class="ai-responses-description">{{description}}</p>
  </header>

  <section class="ai-responses-list">

    {{#modelResponses}}

    <article class="ai-response-card"
             data-model="{{model}}"
             data-provider="{{provider}}"
             data-version="{{modelVersion}}"
             data-generated="{{generatedAt}}">

      <header class="ai-response-meta">
        <h3 class="ai-response-model">{{model}}</h3>

        <div class="ai-response-details">
          <span class="meta-item">Model {{modelVersion}}</span>
          <span class="meta-item">{{provider}}</span>
          <span class="meta-item">Generated {{generatedAt}}</span>
        </div>
      </header>

      <div class="ai-response-content">
        {{renderedHtml}}
      </div>

    </article>

    {{/modelResponses}}

  </section>

</section>
`;
// Exports
module.exports = code;